import Styles from './styles.module.css';
import React, { useState } from 'react';
import { ALL_TAG_VALUES, GENDER_VALUES } from '../../tagConstants';
import StyleTags from '../styleTags/index';
import { IoClose } from 'react-icons/io5';

type TagSectionProps = {
  tags: string[];
  onChange: (tags: string[]) => void;
  error?: string;
};

// 既存の「スタイル(メンズ/レディース)」+「その他のタグ(5カテゴリ、最大5件)」の
// 仕組みをそのまま維持しつつ、表示は必要最小限(選択済みのものだけ)にしている。
const TagSection: React.FC<TagSectionProps> = ({ tags, onChange, error }) => {

  const [ pickerOpen, setPickerOpen ] = useState(false);

  const gender = tags.find((t) => GENDER_VALUES.includes(t)) ?? '';
  const otherTags = tags.filter((t) => ALL_TAG_VALUES.includes(t));

  function selectGender(value: string) {
    const others = tags.filter((t) => !GENDER_VALUES.includes(t));
    onChange([...others, value]);
  }

  function removeTag(value: string) {
    onChange(tags.filter((t) => t !== value));
  }

  // StyleTagsは setStyle(値 or 更新関数) の形で呼ばれるため両方を受ける
  function setStyleFromPicker(action: React.SetStateAction<string[]>) {
    const next = typeof action === 'function' ? (action as (prev: string[]) => string[])(tags) : action;
    onChange(next);
  }

  return (
    <div className={Styles.box}>

      <p className={Styles.groupTitle}>スタイル</p>
      <div className={Styles.chips}>
        {GENDER_VALUES.map((value) => (
          <button
            key={value}
            type="button"
            className={gender === value ? Styles.genderChipActive : Styles.genderChip}
            onClick={() => selectGender(value)}
          >
            {value}
          </button>
        ))}
      </div>
      {error && <p className={Styles.error}>{error}</p>}

      {otherTags.length > 0 && (
        <div className={Styles.chips}>
          {otherTags.map((value) => (
            <span className={Styles.chip} key={value}>
              {value}
              <IoClose className={Styles.chipRemove} onClick={() => removeTag(value)} />
            </span>
          ))}
        </div>
      )}

      <button type="button" className={Styles.addButton} onClick={() => setPickerOpen(true)}>
        ＋ その他のタグを追加
      </button>

      {pickerOpen && (
        <StyleTags style={tags} setStyle={setStyleFromPicker} setSwitchStyle={setPickerOpen} />
      )}
    </div>
  );
}

export default TagSection;
